import { Button, Checkbox, Col, Flex, Form, Input, InputNumber, Row, Select, Tabs, Tooltip } from 'antd';
import { Badge, FloatingLabel } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { RxUpdate } from 'react-icons/rx';
import StatusComponent from '../../globalComponents/StatusComponent';
import SmartButton from '../../globalComponents/SmartButton';
import { BsCartCheckFill } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import { FaCediSign } from "react-icons/fa6";
import { BsJournalText } from "react-icons/bs";



const PosSessionChanges = () => {
  const session = useLoaderData();
  const { success, error } = useOutletContext();
  const [form] = Form.useForm();
  const params = useParams();
  const navigate = useNavigate();
  
  const continueSelling = () => navigate('/pos/session');

  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className='flex justify-between'>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/pos/pos-sessions'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Sessions</Link> / {params.action}
          </h3>
        </div>
      </div>
      <div className={`flex items-center justify-${session.status === 'in_progress' ? 'between' : 'end'} bg-white border`}>
        <Button size='small' type='text' className={`${session.status === 'in_progress' ? 'block' : 'hidden'} font-semibold text-[#189aa0]`} onClick={continueSelling}>CONTINUE SELLING</Button>
        <StatusComponent formValue={session} name='SESSION' />
      </div>
      
      <div className='mt-5 bg-white shadow'>
        <Flex className='border-b m-0' justify='flex-end'>
          <SmartButton icon={<BsCartCheckFill size={'1.4rem'}/>} number={session.orders} text={'Orders'} className='border-s-2 font-semibold' to={`/pos/pos-sessions/${params.action.replaceAll('/', '-')}/orders`}/>
          <SmartButton icon={<TbTruckDelivery size={'1.6rem'}/>} number={session.transfers} text={'Pickings'} className='border-s-2 font-semibold' to={`/pos/pos-sessions/${params.action.replaceAll('/', '-')}/transfers`}/>
          <SmartButton icon={<FaCediSign size={'1.4rem'}/>} number={session.payment} text={'Payments'} className='border-s-2 font-semibold' to={`/pos/pos-sessions/${params.action.replaceAll('/', '-')}/payments`}/>
          <SmartButton icon={<BsJournalText size={'1.4rem'}/>} number={'Journal'} text={'Items'} className='border-s-2 font-semibold'/> 
        </Flex>
        <FloatingLabel
          className='text-2xl ps-3 font-semibold border-0'
          variant="standard"         
          value={session.number}
          readOnly={true}
        />
        <Form 
          form={form}
          size='middle'
          labelAlign='left'
          labelCol={{ span: 7 }}
          labelWrap={true}
          initialValues={session.number ? session : {}}
          autoComplete="off"
          variant='borderless'
          className='p-3'
        >
          <Row>
            <Col md={{span: 11}}>
            <Form.Item labelCol={{md: {span: 10}}} label='Opened By' name='opened_by' className='font-semibold mb-0' >
                <Input type='text' readOnly className='font-normal input-outline-none'/>
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Point of Sale' name='pos' className='font-semibold mb-0' >
                <Input type='text' readOnly className='font-normal input-outline-none'/>              
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Journal Entry' name='journal_entry_id' className='font-semibold mb-0' >
                <Input type='text' readOnly className='font-normal input-outline-none'/>              
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Opening Date' name='opening_date' className='font-semibold mb-0' >
                <Input type='text' readOnly className='font-normal input-outline-none'/>              
              </Form.Item>
              <Form.Item labelCol={{md: {span: 10}}} label='Closing Date' name='closing_date' className='font-semibold mb-0' >
                <Input type='text' readOnly className='font-normal input-outline-none'/>              
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}

export default PosSessionChanges;